import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from './utils/amplitude';
import './LandingPage3.css';
import Footer from './Footer';

function LandingPage3() {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true';
    });
    const [waitlistEmail, setWaitlistEmail] = useState('');
    const [waitlistMessage, setWaitlistMessage] = useState('');
    const [showWaitlistModal, setShowWaitlistModal] = useState(false);

    useEffect(() => {
        trackEvent('page_viewed', { pageName: 'LandingPage3' });
    }, []);

    const handleGoogleSignup = () => {
        trackEvent('button_clicked', { buttonName: 'Google Signup', page: 'LandingPage3' });
        const backendUrl = process.env.NODE_ENV === 'production' 
            ? 'https://proto-backend-d2c1638486b9.herokuapp.com'
            : 'http://localhost:5000';
        window.location.href = `${backendUrl}/auth/google`;
    };

    const handleRequestAccess = () => {
        setShowWaitlistModal(true);
        trackEvent('request_access_clicked', { page: 'LandingPage3' });
    };

    const handleWaitlistSignup = async () => {
        if (!waitlistEmail) {
            setWaitlistMessage('Please enter a valid email.');
            return;
        }
    
        try {
            const response = await fetch('https://proto-backend-d2c1638486b9.herokuapp.com/join-waitlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: waitlistEmail }),
            });
    
            if (response.ok) {
                trackEvent('waitlist_signup', { email: waitlistEmail, page: 'LandingPage3' });
                setWaitlistMessage('Thank you for joining the waitlist!');
                setWaitlistEmail('');
                setTimeout(() => {
                    setShowWaitlistModal(false);
                    setWaitlistMessage('');
                }, 2000);
            } else {
                setWaitlistMessage('Failed to join the waitlist. Please try again.');
            }
        } catch (error) {
            console.error('Error joining waitlist:', error);
            setWaitlistMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="landing-page-3">
            <div className="landing-container">
                {/* Hero Section */}
                <section className="hero-section">
                    <h1 className="gradient-text hero-title">
                        Merra.ai
                        <br/>
                        <br/>
                        Create marketing videos that feel like storytelling
                    </h1>
                </section>

                {/* Example Section */}
                <section className="example-section">
                    <div className="example-content">
                        <p className="example-label">
                            Example: This video was made with 10 random clips and a company description
                        </p>
                        <div className="video-container">
                            <video
                                src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4"
                                controls
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '70vh',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                }}
                                playsInline
                            >
                                <source src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <p className="example-description">
                            The AI made the hook + script + voiceover + subtitle + soundtrack
                        </p>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cta-section">
                    <div className="cta-content">
                        <h2 className="gradient-text cta-title">
                            Ready to create?
                        </h2>
                        <div className="cta-buttons">
                            {isAuthenticated ? (
                                <button onClick={handleGoogleSignup} className="google-btn">
                                    <div className="google-icon" />
                                    Continue with Google
                                </button>
                            ) : (
                                <>
                                    <button onClick={handleGoogleSignup} className="google-btn">
                                        <div className="google-icon" />
                                        Continue with Google
                                    </button>
                                    <button onClick={handleRequestAccess} className="purple-button">
                                        <span>Request access</span>
                                        <span className="purple-button-shimmer"></span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </section>
            </div>

            {/* Waitlist Modal */}
            {showWaitlistModal && (
                <div
                    onClick={() => setShowWaitlistModal(false)}
                    className="modal-overlay"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="modal-content"
                    >
                        <button
                            onClick={() => setShowWaitlistModal(false)}
                            className="modal-close"
                        >
                            ×
                        </button>
                        <h2 className="gradient-text modal-title">
                            Get early access to Merra.ai
                        </h2>
                        <div className="field-wrapper">
                            <input
                                value={waitlistEmail}
                                onChange={(e) => setWaitlistEmail(e.target.value)}
                                placeholder="Your email"
                                type="email"
                                className="field"
                                required
                            />
                            <button
                                onClick={handleWaitlistSignup}
                                className="purple-button"
                            >
                                <span>Join waitlist</span>
                                <span className="purple-button-shimmer"></span>
                            </button>
                            {waitlistMessage && (
                                <p className={`waitlist-message ${waitlistMessage.includes('Thank you') ? 'success' : 'error'}`}>
                                    {waitlistMessage}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
}

export default LandingPage3;

